import { render } from "./index-two.vue?vue&type=template&id=7f91bf0c"
const script = {}

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__